import SplashLoader from '@shared/components/loading/SplashLoader';
import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useAuthStore } from '@shared/hooks/state/AuthContainer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

const LOGIN_PATH = '../login';
const HOME_PATH = '../';

const AuthCallbackPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const queryCode = searchParams.get('code');

    const tryInitializeFromStorage = async () => {
        try {
            const result = await useAuthStore.getState().initializeFromStorage();
            if (result) {
                navigate(HOME_PATH, { replace: true, viewTransition: true });
            } else {
                errorReset();
            }
        } catch (error) {
            errorReset();
        }
    };
    const errorReset = () => {
        useAlertsStore.getState().showError(t('common:login.error'));
        if (!useAuthStore.getState().isLoading) {
            navigate(LOGIN_PATH, { replace: true, viewTransition: true });
        }
    };

    const fetchData = async () => {
        try {
            const result = await useAuthStore.getState().loginFromCode(queryCode || '');
            if (result?.resultType == 'Ok') {
                navigate(HOME_PATH, { replace: true, viewTransition: true });
            } else {
                tryInitializeFromStorage();
            }
        } catch (error) {
            errorReset();
        }
    };

    useEffect(() => {
        if (!queryCode) {
            navigate(LOGIN_PATH, { replace: true, viewTransition: true });
        }
        if (!useAuthStore.getState().isAuthenticated) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <SplashLoader text={t('common:authenticating')} refreshButton />;
};

export default AuthCallbackPage;
